<template>
  <Modal
    :model-value="props?.isOpen.value"
    :close="props?.options?.backgroundClose === false ? () => '' : hide"
    @after-leave="afterLeave"
  >
    <div
      class="modal"
      :class="{ modal_wide: props?.options?.width }"
      :style="{ 'max-width': getMaxWidth }"
    >
      <DefModal v-if="!props?.options?.empty" :padding="props?.options?.padding" @close="hide">
        <slot />
      </DefModal>
      <div v-else :style="`max-width: ${props?.options?.width}`"><slot /></div>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
import { computed, Ref } from 'vue';
import useModal from '@use/useModal/useModal';
import DefModal from '@components/Def/DefModal/DefModal.vue';
import useScreenWidth from '@use/useScreenWidth';

const modal = useModal();
const screenWidth = useScreenWidth();

const props = defineProps<{
  isOpen: Ref;
  options?: {
    width?: string;
    widthTablet?: string;
    widthDesktop?: string;
    backgroundClose?: boolean;
    empty?: boolean;
    padding?: boolean;
  };
  afterLeave: () => void;
}>();

const getMaxWidth = computed(() => {
  if (props.options?.widthDesktop && screenWidth.value >= 992) {
    return props.options?.widthDesktop;
  }
  if (props.options?.widthTablet && screenWidth.value >= 768) {
    return props.options?.widthTablet;
  }
  return props.options?.width || '320px';
});

const hide = () => {
  modal.hide();
};
</script>

<style lang="scss" scoped>
.modal {
  &_wide {
    width: 100%;
  }
}
</style>
